import axios from "axios";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { classNames } from "primereact/utils";
import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import ModalNotifications from "./components/ModalNotifications/ModalNotifications";
import PayPalCheckoutButton from "./components/PayPalCheckoutButton/PayPalCheckoutButton";
import localeText from "./locale";
import logoWhite from "./pages/images/logo-white-horizontal.png";
import apiURI from "./service/Api";
import AreaManagerService from "./service/Cadastros/AreaManagerService";
import GetInfoService from "./service/GetInfoService";
import GetUserInfoService from "./service/GetUserInfoService";
import { formatPrice } from "./utilities/formatPrice";
import paypalImg from "./pages/images/paypal.png";
import masterCardImg from "./pages/images/masterCard.png";
import americanExpress from "./pages/images/expressoAmericano.png";
import visa from "./pages/images/visa.png";
import PagamentoSeguro from "./pages/images/pagamentoSeguro.png";
import UserInitialsAvatar from "./components/UserInitialsAvatar/UserInitialsAvatar";

const AppTopbar = (props) => {
  const { currency } = props;

  const [changePasswordVisible, setChangePasswordVisible] = useState(false);
  const [upgradeAccountVisible, setUpgradeAccountVisible] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingBusiness, setLoadingBusiness] = useState(false);
  const [loadingArea, setLoadingArea] = useState(false);
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [currencyText, setCurrencyText] = useState("$");
  const [priceForex, setPriceForex] = useState(0);
  const [priceBusiness, setPriceBusiness] = useState(0);
  const [priceArea, setPriceArea] = useState(0);
  const [voucher, setVoucher] = useState("");
  const [redirectCounting, setRedirectCounting] = useState(false);
  const [redirectCounter, setRedirectCounter] = useState(20);
  const [useVoucherCheck, setUseVoucherCheck] = useState(false);
  const [plan, setPlan] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const toast = useRef(null);
  const toastErr = useRef(null);
  const toastUpgrade = useRef(null);
  const [priceSeller, setPriceSeller] = useState(0);
  const [loadingSeller, setLoadingSeller] = useState(false);
  const [cancelAccountVisible, setCancelAccountVisible] = useState(false);
  const [cancelAccount, setCancelAccount] = useState("");
  const [cancelAccountConfirmed, setCancelAccountConfirmed] = useState(false);

  const footer = (
    <div>
      <Button
        label={localeText("cancel")}
        icon="pi pi-times"
        onClick={() => setChangePasswordVisible(false)}
        disabled={loading}
      />
      <Button
        label={localeText("confirm")}
        icon="pi pi-check"
        onClick={() => changePassword(currentPassword, newPassword, confirmNewPassword)}
        loading={loading}
      />
    </div>
  );

  const history = useHistory();
  const topbarMenuClassName = classNames("topbar-menu fadeInDown", {
    "topbar-menu-visible": props.topbarMenuActive,
  });
  const profileItemClassName = classNames("user-profile", {
    "active-topmenuitem": props.activeTopbarItem === "profile",
  });

  const isProfilePopup = props.profileMode === "popup" || props.isHorizontal;

  async function logout() {
    if (localStorage.getItem("__extraconomy_devicetoken__")) {
      const token = localStorage.getItem("__extraconomy_token");
      const username = localStorage.getItem("__extraconomy_username");
      const deviceId = localStorage.getItem("__extraconomy_devicetoken__");

      const deviceJson = {
        user: { username },
        deviceid: JSON.parse(deviceId),
      };

      await axios({
        method: "post",
        url: `${apiURI}/device/unregisterdevice`,
        data: deviceJson,
        headers: { Authorization: "Bearer " + token },
      });
    }

    if (JSON.parse(localStorage.getItem("__extraconomy_ismobile__"))) {
      localStorage.removeItem("__extraconomy_token");
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          isLogout: true,
        })
      );
    }
    localStorage.removeItem("__extraconomy_token");
    localStorage.removeItem("__extraconomy_username");
    localStorage.removeItem("__extraconomy_order");
    localStorage.removeItem("__extraconomy_order_fringe_benefit");
    window.location.replace("/login");
  }

  const getUserInfoService = new GetUserInfoService();

  async function changePassword(currentPassword, newPassword, confirmNewPassword) {
    try {
      if (newPassword !== confirmNewPassword) {
        toastErr.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("passwordFieldsMismatched"),
          life: 6000,
        });
        return;
      }

      setLoading(true);

      const res = await getUserInfoService.postChangePassword(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username"),
        currentPassword,
        newPassword
      );

      if (res.messageCode !== 200000) {
        setChangePasswordVisible(false);
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoading(false);
      } else {
        setChangePasswordVisible(false);
        toast.current.show({
          severity: "success",
          summary: localeText("success"),
          detail: localeText("passwordChangedSuccessfully"),
          life: 6000,
        });
        setLoading(false);
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      setChangePasswordVisible(false);
      setLoading(false);
      console.log(e);
    }
  }

  const getInfoService = new GetInfoService();

  async function upgradePlan(plan) {
    if (plan > 0) {
      try {
        // upgrade para plano 1 = Partner, 2 = Area Manager, 3 = promoter, 4 = Seller
        if (plan === 1) setLoadingBusiness(true);
        else if (plan === 2) setLoadingArea(true);
        else setLoadingSeller(true);

        let fullPricePlan;
        if (plan === 1) fullPricePlan = priceBusiness;
        else if (plan === 2) fullPricePlan = priceArea;
        else fullPricePlan = priceSeller;

        if (currencyText !== process.env.REACT_APP_BASE_PAYPAL_CURRENCY) {
          const resForex = await getInfoService.getForexRate(
            currencyText,
            process.env.REACT_APP_BASE_PAYPAL_CURRENCY
          );
          setPriceForex(parseFloat((fullPricePlan * resForex.result).toFixed(2)));
        } else {
          setPriceForex(fullPricePlan);
        }

        if (plan === 1) setLoadingBusiness(false);
        else if (plan === 2) setLoadingArea(false);
        else setLoadingSeller(false);
      } catch (e) {
        console.log(e);
      }
    }
  }

  useEffect(() => {
    let cancel = false;

    async function fetchPrices() {
      if (upgradeAccountVisible) {
        setLoading(true);

        const basePrice = await getInfoService.getPlanListByCurrency(currency);
        if (cancel) return;

        const currentPlanBusiness = basePrice.result.find((item) => item.id === 1);
        setPriceBusiness(currentPlanBusiness.price);

        const currentSeller = basePrice.result.find((item) => item.id === 4);
        setPriceSeller(currentSeller.price);

        const currentPlanArea = basePrice.result.find((item) => item.id === 2);

        if (props.userTypeInfo === "Partner")
          setPriceArea(currentPlanArea.price - currentPlanBusiness.price);
        else if (props.userTypeInfo === "Seller")
          setPriceArea(currentPlanArea.price - currentSeller.price);
        else {
          setPriceArea(currentPlanArea.price);
        }

        setLoading(false);

        setCurrencyText(currency);
      }
    }

    fetchPrices();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [upgradeAccountVisible]);

  const areaManagerService = new AreaManagerService();

  async function upgradeWithVoucher() {
    try {
      setLoadingArea(true);

      if (voucher.length === 0) {
        toastUpgrade.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("pleaseFillOutAll"),
          life: 6000,
        });
        setLoadingArea(false);
        return;
      }

      const resAreaManager = await areaManagerService.upgrade(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username"),
        voucher,
        true
      );

      if (resAreaManager.messageCode !== 200000) {
        toastUpgrade.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === resAreaManager.messageCode).message,
          life: 6000,
        });
        if (resAreaManager.messageCode === 500000) console.log(resAreaManager);
        setLoadingArea(false);
      } else {
        toastUpgrade.current.show({
          severity: "success",
          summary: localeText("success"),
          detail: localeText("upgradedSuccessfully"),
          life: 6000,
        });
        counterStart();
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      setLoadingArea(false);
      console.log(e);
    }
  }

  useEffect(() => {
    (async () => {
      const response = await getUserInfoService.getUserNotifications(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username")
      );

      setNotifications(response.result.filter((notification) => !notification.sent));
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function counterStart() {
    setRedirectCounting(true);
    let timesRun = 20;
    let interval = setInterval(() => {
      setRedirectCounter(timesRun);
      timesRun -= 1;
      if (timesRun === -1) {
        clearInterval(interval);
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
    }, 1000);
  }

  async function cancelAccountHandler() {
    try {
      setLoading(true);

      const res = await getUserInfoService.postCancelAccount(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username"),
        currentPassword
      );

      if (res.messageCode !== 200001) {
        console.log("erro");
        setCurrentPassword("");
        setCancelAccountConfirmed(false);
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 4000,
        });
        setLoading(false);
      } else {
        setCurrentPassword("");
        setCancelAccountConfirmed(false);
        toast.current.show({
          severity: "success",
          summary: localeText("success"),
          detail: localeText("accountCanceledSuccessfully"),
          life: 4000,
        });

        setTimeout(() => {
          setLoading(false);
          localStorage.removeItem("__extraconomy_token");
          localStorage.removeItem("__extraconomy_username");
          window.location.replace("/login");
        }, 4500);
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      setCancelAccountConfirmed(false);
      setLoading(false);
      console.log(e);
    }
  }

  function confirmCancelAccount() {
    switch (localStorage.getItem("__extraconomy_locale")) {
      case "pt":
        if (cancelAccount === "CANCELAR") {
          setCancelAccountConfirmed(true);
          setCancelAccountVisible(false);
          setCancelAccount("");
        } else {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("cancelAccountError"),
            life: 6000,
          });
        }
        break;
      case "it":
        if (cancelAccount === "CANCELLARE") {
          setCancelAccountConfirmed(true);
          setCancelAccountVisible(false);
          setCancelAccount("");
        } else {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("cancelAccountError"),
            life: 6000,
          });
        }
        break;
      case "es":
        if (cancelAccount === "CANCELAR") {
          setCancelAccountConfirmed(true);
          setCancelAccountVisible(false);
          setCancelAccount("");
        } else {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("cancelAccountError"),
            life: 6000,
          });
        }
        break;
      default:
        if (cancelAccount === "CANCEL") {
          setCancelAccountConfirmed(true);
          setCancelAccountVisible(false);
          setCancelAccount("");
        } else {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("cancelAccountError"),
            life: 6000,
          });
        }
        break;
    }
  }

  return (
    <div className="layout-topbar" style={{ zIndex: "998" }}>
      <button
        className="layout-topbar-logo p-link"
        id="step-1-mobile"
        onClick={() =>
          history.push(
            `${JSON.parse(localStorage.getItem("__extraconomy_ismobile__")) ? "/shop" : "/"}`
          )
        }
      >
        <img id="layout-topbar-logo" src={logoWhite} alt="babylon-layout" />
      </button>

      <button className="layout-menu-button p-link" onClick={props.onMenuButtonClick}>
        <i className="pi pi-bars"></i>
      </button>

      <button id="topbar-menu-button" className="p-link" onClick={props.onTopbarMenuButtonClick}>
        <i className="pi pi-ellipsis-v"></i>
      </button>

      <Toast ref={toast} position="top-right" />
      {!props.adminBackoffice && (
        <>
          <Dialog
            header={localeText("upgradeAccount")}
            visible={upgradeAccountVisible}
            onHide={() => {
              if (
                !loading &&
                !loadingArea &&
                !loadingBusiness &&
                !redirectCounting &&
                !loadingSeller
              ) {
                setUpgradeAccountVisible(false);
                setPlan(0);
              }
            }}
            breakpoints={{ "960px": "85vw" }}
            style={{ width: "50vw" }}
            draggable={false}
          >
            <Toast ref={toastUpgrade} position="top-right" />
            {plan > 0 && priceForex > 0 ? (
              <>
                {!redirectCounting ? (
                  <>
                    {plan === 2 && useVoucherCheck && (
                      <ul className="list-none mx-0 mt-0 mb-4 p-0 text-center">
                        <li>
                          <label htmlFor="voucher">{localeText("voucher")}</label>
                        </li>
                        <li className="mt-2">
                          <InputText
                            value={voucher}
                            onChange={(e) => setVoucher(e.target.value)}
                            name="voucher"
                          />
                        </li>
                        <li className="my-4">
                          <Button
                            label={localeText("upgradeWithVoucher")}
                            onClick={() => upgradeWithVoucher()}
                            loading={loadingArea}
                          />
                        </li>
                      </ul>
                    )}

                    {(loadingArea || loadingBusiness || loadingSeller) && (
                      <div className="text-center">
                        <i className="pi pi-spin pi-spinner text-8xl text-500 my-8"></i>
                      </div>
                    )}

                    {!loadingArea && !loadingBusiness && !loadingSeller && (
                      <>
                        {(plan !== 2 || !useVoucherCheck) && (
                          <div className="my-4 lg:w-8 md:w-8 w-full m-auto">
                            <PayPalCheckoutButton
                              upgrade={true}
                              plan_={plan}
                              price={priceForex}
                              loading={loading}
                              setLoading={setLoading}
                              toastUpgrade={toastUpgrade}
                            />
                          </div>
                        )}
                        {plan === 2 && !loading && !redirectCounting && (
                          <div className="mb-4 flex justify-content-center align-items-center">
                            <label htmlFor="usevouchercheck">
                              {localeText("doYouHaveVoucher")}
                            </label>
                            <Checkbox
                              className="sc-checkbox"
                              name="usevouchercheck"
                              onChange={(e) => setUseVoucherCheck(e.checked)}
                              checked={useVoucherCheck}
                            ></Checkbox>
                          </div>
                        )}
                      </>
                    )}

                    {!loading && (
                      <Button
                        className="p-button"
                        label={localeText("previous")}
                        icon="pi pi-arrow-left"
                        onClick={() => setPlan(0)}
                      />
                    )}
                  </>
                ) : (
                  <div style={{ width: "90%" }} className="m-auto">
                    <p className="w-full my-4">{localeText("upgradedSuccessfullyText")}</p>
                    <div className="flex justify-content-center">
                      <Button
                        label={localeText("login")}
                        className="p-button mt-2 mb-4"
                        onClick={() => {
                          localStorage.removeItem("__extraconomy_token");
                          localStorage.removeItem("__extraconomy_username");
                          window.location.replace("/login");
                        }}
                      />
                    </div>
                    <p className="font-bold text-xl mt-2 mb-6 text-center text-900">
                      {localeText("youWillBeRedirectedIn")} {redirectCounter}{" "}
                      {localeText("seconds")}
                    </p>
                  </div>
                )}
              </>
            ) : (
              <>
                {loading ? (
                  <div className="text-center">
                    <i className="pi pi-spin pi-spinner text-8xl text-500 my-8"></i>
                  </div>
                ) : (
                  <ul className="list-none m-0 p-0 lg:w-8 md:w-8 w-full m-auto my-4">
                    {(props.userTypeInfo === "Customer" ||
                      props.userTypeInfo === "Partner" ||
                      props.userTypeInfo === "Seller") && (
                      <>
                        <li>
                          <Button
                            label={
                              <>
                                {localeText("upgradeTo")} <span className="font-bold">Manager</span>{" "}
                                ({currency} {formatPrice(priceArea)})
                              </>
                            }
                            className="p-button p-button-warning p-4 w-full text-xl"
                            style={{ borderRadius: "1.5em" }}
                            onClick={() => {
                              setPlan(2);
                              upgradePlan(2);
                            }}
                            loading={loadingArea}
                          />
                        </li>
                        <li className="mt-2 font-bold">
                          <Link to="/areamanager">{localeText("learnMoreAboutThePlan")}</Link>
                        </li>
                      </>
                    )}
                    {(props.userTypeInfo === "Customer" || props.userTypeInfo === "Partner") && (
                      <>
                        <li className="mt-4">
                          <Button
                            label={
                              <>
                                {localeText("upgradeTo")} <span className="font-bold">Seller</span>{" "}
                                ({currency} {formatPrice(priceSeller)})
                              </>
                            }
                            className="p-button p-4 w-full text-xl"
                            style={{ borderRadius: "1.5em" }}
                            onClick={() => {
                              setPlan(4);
                              upgradePlan(4);
                            }}
                            loading={loadingSeller}
                          />
                        </li>
                        <li className="mt-2 font-bold">
                          <Link to="/seller">{localeText("learnMoreAboutThePlan")}</Link>
                        </li>
                      </>
                    )}

                    {props.userTypeInfo === "Customer" && (
                      <>
                        <li className="mt-4">
                          <Button
                            label={
                              <>
                                {localeText("upgradeTo")} <span className="font-bold">Partner</span>{" "}
                                ({currency} {formatPrice(priceBusiness)})
                              </>
                            }
                            className="p-button p-4 w-full text-xl bg-blue-400 border-blue-400 hover:bg-blue-500 hover:border-blue-500"
                            style={{ borderRadius: "1.5em" }}
                            onClick={() => {
                              setPlan(1);
                              upgradePlan(1);
                            }}
                            loading={loadingBusiness}
                          />
                        </li>
                        <li className="mt-2 font-bold">
                          <Link to="/businesspartner">{localeText("learnMoreAboutThePlan")}</Link>
                        </li>
                      </>
                    )}

                    <div className="flex mt-4 justify-content-center align-items-center w-full flex-wrap gap-2 mx-auto">
                      <img
                        src={paypalImg}
                        alt="paypal"
                        title="paypal"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <img
                        src={americanExpress}
                        alt="americanExpress"
                        title="americanExpress"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <img
                        src={masterCardImg}
                        alt="mastercard"
                        title="mastercard"
                        style={{ width: "30px", height: "20px" }}
                      />
                      <img
                        src={visa}
                        alt="visa"
                        style={{ width: "35px", height: "15px" }}
                        title="visa"
                      />
                    </div>
                    <div className="flex justify-content-center align-items-center gap-2 mt-3">
                      <p className="m-0 text-xs">{localeText("safePayment")}</p>
                      <img
                        src={PagamentoSeguro}
                        alt=""
                        style={{ width: "20px" }}
                        title={localeText("safePayment")}
                      />
                    </div>
                  </ul>
                )}
              </>
            )}
          </Dialog>
          <Dialog
            header={localeText("changePassword")}
            visible={changePasswordVisible}
            footer={() => {
              return footer;
            }}
            onHide={() => setChangePasswordVisible(false)}
            breakpoints={{ "960px": "85vw" }}
            style={{ width: "50vw" }}
            draggable={false}
          >
            <Toast ref={toastErr} position="top-right" />
            <ul className="list-none mx-0 my-4 p-0 w-8 mx-auto">
              <li>
                <label htmlFor="current-password" className="text-sm">
                  <b>{localeText("currentPassword")}</b>
                </label>
              </li>
              <li className="mt-2">
                <InputText
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  name="current-password"
                  className="w-full"
                  type="password"
                />
              </li>
              <li className="mt-2">
                <label htmlFor="new-password" className="text-sm">
                  <b>{localeText("newPassword")}</b>
                </label>
              </li>
              <li className="mt-2">
                <InputText
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  name="new-password"
                  className="w-full"
                  type="password"
                />
              </li>
              <li className="mt-2">
                <label htmlFor="confirm-password" className="text-sm">
                  <b>{localeText("confirmPassword")}</b>
                </label>
              </li>
              <li className="mt-2">
                <InputText
                  value={confirmNewPassword}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                  name="confirm-password"
                  className="w-full"
                  type="password"
                />
              </li>
            </ul>
          </Dialog>
        </>
      )}
      <Dialog
        header={localeText("writeCancelToConfirm")}
        visible={cancelAccountVisible}
        footer={() => {
          return (
            <div>
              <Button
                label={localeText("cancel")}
                icon="pi pi-times"
                onClick={() => {
                  setCancelAccount("");
                  setCancelAccountVisible(false);
                }}
                disabled={loading}
              />
              <Button
                label={localeText("confirm")}
                icon="pi pi-check"
                onClick={() => confirmCancelAccount()}
                loading={loading}
              />
            </div>
          );
        }}
        onHide={() => {
          setCancelAccount("");
          setCancelAccountVisible(false);
        }}
        breakpoints={{ "960px": "85vw" }}
        style={{ width: "50vw" }}
        draggable={false}
      >
        <Toast ref={toastErr} position="top-right" />
        <InputText
          value={cancelAccount}
          onChange={(e) => setCancelAccount(e.target.value)}
          name="cancel-account"
          className="w-full"
          type="text"
        />
      </Dialog>
      <Dialog
        header={localeText("confirmYourPassword")}
        visible={cancelAccountConfirmed}
        footer={() => {
          return (
            <div>
              <Button
                label={localeText("cancel")}
                icon="pi pi-times"
                onClick={() => {
                  setCurrentPassword("");
                  setCancelAccountConfirmed(false);
                }}
                disabled={loading}
              />
              <Button
                label={localeText("confirm")}
                icon="pi pi-check"
                onClick={() => cancelAccountHandler()}
                loading={loading}
              />
            </div>
          );
        }}
        onHide={() => {
          setCurrentPassword("");
          setCancelAccountConfirmed(false);
        }}
        breakpoints={{ "960px": "85vw" }}
        style={{ width: "50vw" }}
        draggable={false}
      >
        <Toast ref={toastErr} position="top-right" />
        <label htmlFor="current-password" className="text-sm">
          <b>{localeText("currentPassword")}</b>
        </label>
        <InputText
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          name="current-password"
          className="w-full"
          type="password"
        />
      </Dialog>
      <ModalNotifications notifications={notifications} />
      <ul className={topbarMenuClassName}>
        {isProfilePopup && (
          <li className={profileItemClassName}>
            {!props.adminBackoffice ? (
              <button className="p-link" onClick={(e) => props.onTopbarItemClick(e, "profile")}>
                <UserInitialsAvatar
                  avatarUrl={props?.userInfo?.urlAvatar}
                  firstName={props?.userInfo?.firstname}
                  lastName={props?.userInfo?.surname}
                  className="topbar-user-avatar"
                  style={{ fontSize: "0.75rem" }}
                  alt="babylon-layout"
                />
                <span className="topbar-item-name">
                  {props.userInfo.firstname} {props.userInfo.surname}
                </span>
              </button>
            ) : (
              <button className="p-link" onClick={(e) => props.onTopbarItemClick(e, "profile")}>
                <img
                  alt="babylon-layout"
                  className="border-circle"
                  src="https://res.cloudinary.com/dwpu3xryx/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1655947145/user_avatar_onpaw0.png"
                />
                <span className="topbar-item-name">Admin</span>
              </button>
            )}
            <ul className={classNames({ fadeInDown: !props.isMobile() })}>
              {!props.adminBackoffice && (
                <>
                  <li className="p-2" role="menuitem">
                    <p>
                      {localeText("welcome")}, {props.userInfo.firstname}
                    </p>
                  </li>

                  <li role="menuitem">
                    <Link to="/dashboard-editprofile">
                      <button className="p-link">
                        <i className="pi pi-pencil"></i>
                        <span>{localeText("editProfile")}</span>
                      </button>
                    </Link>
                  </li>

                  <li role="menuitem">
                    <button className="p-link" onClick={() => setCancelAccountVisible(true)}>
                      <i className="pi pi-user-minus"></i>
                      <span>{localeText("cancelAccount")}</span>
                    </button>
                  </li>

                  <li role="menuitem">
                    <button className="p-link" onClick={() => setChangePasswordVisible(true)}>
                      <i className="pi pi-lock"></i>
                      <span>{localeText("changePassword")}</span>
                    </button>
                  </li>

                  {(props.userTypeInfo === "Customer" ||
                    props.userTypeInfo === "Partner" ||
                    props.userTypeInfo === "Seller") && (
                    <li role="menuitem">
                      <button className="p-link" onClick={() => history.push("/dashboard-upgrade")}>
                        <i className="pi pi-chart-line"></i>
                        <span>{localeText("upgradeAccount")}</span>
                      </button>
                    </li>
                  )}
                </>
              )}

              <li role="menuitem">
                <button className="p-link" onClick={() => logout()}>
                  <i className="pi pi-sign-out"></i>
                  <span>{localeText("logout")}</span>
                </button>
              </li>
            </ul>
          </li>
        )}
      </ul>
      {!JSON.parse(localStorage.getItem("__extraconomy_ismobile__")) && (
        <div className="flex align-items-center justify-content-between">
          {props.adminBackoffice && (
            <span className="text-0 font-bold text-2xl mt-2 ml-4">Admin Backoffice</span>
          )}
        </div>
      )}
    </div>
  );
};

export default AppTopbar;
